import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-unavailable',
  imports: [],
  templateUrl: './data-unavailable.component.html',
  styleUrl: './data-unavailable.component.scss'
})
export class DataUnavailableComponent implements OnInit {
  @Input() content: any = "No data available";
  constructor() { }
  ngOnInit() {
    console.log(this.content, "content")
  }
}
